import './polyfills';

require('./react/Root')
